import api from '@/utils/api'

export default {
    getConfig() {
        return api.get(`config`)
    }
}
